import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoUserRole } from '@pit/frontend-model';
import { DtoUserRoleStoreFactory } from './dto.user.role.store.factory';

@Injectable({
    providedIn: 'root'
})
export class DtoUserRoleStoreFacade extends EntityStoreFacade<IDtoUserRole> {

    constructor(store: Store<IDtoUserRole>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoUserRoleStoreFactory.instance, store, 'DtoUserRole', dataServiceAccessor, eventService);
    }

    public getUserRolesForDevice$(): Observable<IDtoUserRole[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.user.roles.device'));
    }

    public async getUserRolesForDeviceAsync(): Promise<IDtoUserRole[]> {
        let result: IDtoUserRole[] = null;
        try {
            result = await this.getUserRolesForDevice$().pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

    public getUserRolesForWeb$(): Observable<IDtoUserRole[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.user.roles.web'));
    }

    public async getUserRolesForWebAsync(): Promise<IDtoUserRole[]> {
        let result: IDtoUserRole[] = null;
        try {
            result = await this.getUserRolesForWeb$().pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

}
